import { createActions } from '~/utils/redux';

export const {
  samlSetInitialState,
  samlFormValueUpdate,
  samlFormReset,
  samlConfigsSet,
  samlConfigEdit,
} = createActions('saml', [
  'setInitialState',
  'formValueUpdate',
  'formReset',
  'configsSet',
  'configEdit',
]);
